import React from 'react';
import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { emailUnsubscribe as orgConfig } from 'org/configs/modules.config';
import Confirmed from 'core/modules/EmailUnsubscribe/components/Confirmed';

const defaultConfig = {
  defaults: {
    components: {
      Confirmed,
    },
    getGlobalConfirmText: (streamTitle) => (
      <p>
        Please confirm that you would like to unsubscribe from all {streamTitle} newsletters. This does not
        include email confirming rewards you have earned or other account related information.
      </p>
    ),
    getFavoritesConfirmText: (streamTitle, siteUrl) => (
      <>
        <p>
          If you would like to change which stores are your favorite,
          please manage your favorites <a href={`${siteUrl}/favorites____.htm`}>here</a>.
        </p>
        <p>Please confirm below that you would like to stop receiving {streamTitle} emails.</p>
      </>
    ),
    getDefaultConfirmText: () => (
      <p>Please confirm that you would like to unsubscribe from the following newsletter:</p>
    ),
    getConfirmedText: (data) => (
      <>
        <div className="mn_alertInfo mn_success">Thank you. Your changes have been saved.</div>
        <p>
          Please allow up to 10 business days for any changes to take effect.
          You may also log in any time to manage your <a href={data.profileLoginUrl}>Communication Preferences</a>.
        </p>
      </>
    ),
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
